"use strict";

exports.__esModule = true;
exports.CalendarEventOccursWeeklyField = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactFinalForm = require("react-final-form");
var _core = require("@blueprintjs/core");
var _Core = require("../../Core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var WEEKDAYS = ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"];
var WEEKDAY_NAMES = WEEKDAYS.map(function (_, i) {
  return new Date(1970, 0, i + 5).toLocaleString(undefined, {
    weekday: "long"
  });
});
var validate = function validate(input) {
  if (!Array.isArray(input) || input.length === 0) {
    return "Must select at least one day.";
  }
};
var WeekdayCheckboxList = function WeekdayCheckboxList(props) {
  return WEEKDAYS.map(function (day, index) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line
      _react["default"].createElement("label", {
        key: day,
        className: "bp6-control bp6-checkbox"
      }, /*#__PURE__*/_react["default"].createElement("input", {
        component: "input",
        type: "checkbox",
        value: day,
        checked: props.value.indexOf(day) > -1,
        onChange: function onChange(e) {
          var checked = e.target.checked;
          var value = checked ? props.value.concat(day) : props.value.filter(function (item) {
            return item !== day;
          });
          return props.onChange(value);
        }
      }), " ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "bp6-control-indicator"
      }), WEEKDAY_NAMES[index])
    );
  });
};
var CalendarEventOccursWeeklyField = exports.CalendarEventOccursWeeklyField = function CalendarEventOccursWeeklyField(_ref) {
  var prefix = _ref.prefix;
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, {
    name: prefix + ".occursWeekly",
    validate: validate
  }, function (_ref2) {
    var input = _ref2.input,
      meta = _ref2.meta;
    return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      intent: meta.error ? "danger" : "secondary",
      helperText: meta.error || translate("CalenderEventOccursWeeklyField.helperText", "The days of the week this event repeats on."),
      label: translate("CalenderEventOccursWeeklyField.label", "Days of Week")
    }, /*#__PURE__*/_react["default"].createElement(WeekdayCheckboxList, input));
  });
};